module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isWeixin) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "20px"
    }
  }, [_vm._v("\n    请在微信浏览器中打开\n  ")]) : [_c('wx-open-launch-weapp', {
    attrs: {
      "id": "launch-btn",
      "username": "gh_691c02fc94f9",
      "path": _vm.pathData
    }
  }, [_c('script', {
    attrs: {
      "type": "text/wxtag-template"
    }
  }, [_vm._v("\n            <style>.mpbtn {\n                    padding: 12px;\n                    display: block;\n                    background: #409eff;\n                    margin: auto;\n                    border: none;\n                    border-radius: 10px;\n                    color: #ffffff;\n                    margin-top: 40px;\n                    width: 320px;\n                    margin-left:50px;\n                  }</style>\n             <button class=\"mpbtn\">打开腾慧直播小程序</button>\n      ")])])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6732b793"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/goWechat.vue
// module id = 529
// module chunks = 0